/**
 * The event name used by the global event bus to communicate between emitters and the listener.
 * @type {String}
 */
export const EVENT_NAME = 'OBS::MIXPANEL';

/**
 * The authentication token for our development environment Mixpanel.
 * @type {String}
 */
export const MIXPANEL_DEV_TOKEN = '2bca6d55b3b01ad8b62cbaf84a4c1962';

/**
 * Development environment identifier.
 * @type {String}
 */
export const DEVELOPMENT = 'development';

/**
 * The event name for page views.
 * @type {String}
 */
export const PAGE_VIEW = 'Viewed page';

/**
 * The warning message logged when track was called without a user ID.
 * @type {String}
 */
export const USER_ID_WARNING = 'Mixpanel tracking must be provided a user ID to work';

/**
 * The error message thrown when the module was instantiated without a token.
 * @type {String}
 */
export const TOKEN_ERROR = 'Mixpanel listener must be provided a valid Mixpanel token';
